module.exports = __webpack_public_path__ + "img/73.079823d3.png";